module.exports = __webpack_public_path__ + "static/media/number-of-sports-icon.7c113cf3.svg";